/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_HintInputs */

const cs_sreality_seller_hint = /** @type {(inputs: Sreality_Seller_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzerujete pod firemním RK. Tady je váš Seznam login na Sreality, ne importní klíče (ty jsou v Integracích).`)
};

const en_sreality_seller_hint = /** @type {(inputs: Sreality_Seller_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You publish under the office RK. This is your Seznam login on Sreality, not the import keys (those sit in Integrations).`)
};

/**
* | output |
* | --- |
* | "You publish under the office RK. This is your Seznam login on Sreality, not the import keys (those sit in Integrations)." |
*
* @param {Sreality_Seller_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_hint = /** @type {((inputs?: Sreality_Seller_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_hint(inputs)
	return cs_sreality_seller_hint(inputs)
});